import { CheckScannerUiResult, CheckScanningResult, handleImageInput, mapRTUUIResult, withSBErrorHandling, } from '../types';
import { ScanbotSDKPlugin } from './Definitions';
/**
 * @internal
 * @hidden
 */
export const ScanbotCheckImpl = {
    async scanFromImage(params) {
        return withSBErrorHandling(async () => new CheckScanningResult(await ScanbotSDKPlugin.scanCheckFromImage({
            configuration: params.configuration,
            image: handleImageInput(params.image),
        })));
    },
    async startScanner(configuration) {
        return withSBErrorHandling(async () => mapRTUUIResult(await ScanbotSDKPlugin.startCheckScanner(configuration), CheckScannerUiResult));
    },
};
//# sourceMappingURL=CheckScannerImpl.js.map